export default __webpack_public_path__ + "static/media/dalirpo-iot.b9cee655.jpeg";